// extracted by mini-css-extract-plugin
export default {"container":"Cooldown_container__X1DXS","cooldownCircle":"Cooldown_cooldownCircle__h4Ait","cutout":"Cooldown_cutout__+ikHZ","number":"Cooldown_number__WiT0e"};